import { render, staticRenderFns } from "./NgbTeamMembersList.vue?vue&type=template&id=93f4c776"
import script from "./NgbTeamMembersList.vue?vue&type=script&lang=js"
export * from "./NgbTeamMembersList.vue?vue&type=script&lang=js"
import style0 from "./NgbTeamMembersList.vue?vue&type=style&index=0&id=93f4c776&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports